module.exports = __webpack_public_path__ + "img/hr-centrifuge-A.84ba371a.png";